/**
 * Shared types for Outbound Emails
 *
 * These constants and types are shared between frontend, backend, and RPC contracts
 * to ensure type consistency across the codebase.
 */

/**
 * Outbound email status values
 * - pending: Email is queued to be sent
 * - draft: Email is saved for review before sending
 * - sent: Email was successfully sent
 * - failed: Email sending failed
 * - bounced: Email was rejected by recipient server
 */
export const OUTBOUND_EMAIL_STATUSES = [
  "pending",
  "draft",
  "sent",
  "failed",
  "bounced",
] as const;

export type OutboundEmailStatus = (typeof OUTBOUND_EMAIL_STATUSES)[number];

/**
 * Importance (priority) flag for outgoing email messages.
 *
 * Mirrors Microsoft Graph's `importance` property so the value can be passed
 * straight through to the `sendMail` payload. `normal` is the default; AR reps
 * can mark a collection email as `high` to signal urgency to the recipient.
 *
 * @see https://learn.microsoft.com/en-us/graph/api/resources/message?view=graph-rest-1.0#properties
 */
export const EMAIL_IMPORTANCE_VALUES = ["low", "normal", "high"] as const;

export type EmailImportance = (typeof EMAIL_IMPORTANCE_VALUES)[number];

export const DEFAULT_EMAIL_IMPORTANCE: EmailImportance = "normal";
